import { i18n } from "@/i18n";
import { useUserStore } from "@/stores/user.js";
import { useToast } from "vue-toastification";
import Router from "@/router/appRouter.js";

function getError(error_code, params) {
  return i18n.global.te(`error.${error_code}`)
    ? i18n.global.t(`error.${error_code}`, params)
    : i18n.global.t("error.ERROR_UNKNOWN");
}

function traduceAccessError(error) {
  if (![401, 410].includes(error.code)) return;

  const toast = useToast();

  const logoutError = [
    "ERROR_AUTH_INVALID_TOKEN",
    "COMPANY_PERMISSION_DENIED",
    "ERROR_AUTH_MISSING_TOKEN",
  ];

  if (logoutError.includes(error.key)) {
    const { logout } = useUserStore();
    logout();
  }

  if (error.key === "ERROR_PERMISSIONS_FORBIDDEN_ACTION") {
    toast.info(getError("ERROR_PERMISSIONS_FORBIDDEN"));
    Router.push({ name: "home" });
  }
}

function catchError(error) {
  if (error.response) return error.response.data;

  const toast = useToast();

  toast.error(getError("ERROR_UNKNOWN"));

  throw error;
}

export { getError, traduceAccessError, catchError };
